export default __webpack_public_path__ + "static/media/process3.b2704e71.png";